module.exports = __webpack_public_path__ + "img/certificates-icon-active.3c6f6986.svg";